import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'arregloPuntosIntermedios'
})
export class arregloDePuntosIntermedios implements PipeTransform { 
    constructor(){}
//Convierte un objeto de puntos intermedios en un arreglo.
    transform(puntosItermedios:any) {  
        let arregloDePuntos=[]; //Configuracion de un arreglo vacio
        for (const key in puntosItermedios) {
            arregloDePuntos.push({key,...puntosItermedios[key]}) //recorre el objeto y pushea dentro del arreglo cada objeto encontrado
        }
        return arregloDePuntos
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/arreglo-puntos-intermedios.pipe.ts